// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"styles_tooltipWrapper__JE4+D","top":"styles_top__Vxv-S","right":"styles_right__rTmQI","bottom":"styles_bottom__-+nqm","left":"styles_left__jQKws"};